import { render, staticRenderFns } from "./UsuariosLista.vue?vue&type=template&id=b2957f0e&scoped=true&"
import script from "./UsuariosLista.vue?vue&type=script&lang=js&"
export * from "./UsuariosLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2957f0e",
  null
  
)

export default component.exports